module.exports = __webpack_public_path__ + "img/cabbage-posterized-medium-alpha.38a9e304.png";